import React, { useState, useEffect, memo, useMemo, useRef } from "react";
import Table from '../../../../../../components/CustomTable';
import { Link, withRouter } from "react-router-dom";
import { useFetchPlatformData } from "../../../../../../hooks/useFetchPlatformData";
import { useFetchCountryListData } from "../../../../../../hooks/useFetchCountryListData";
import { useFetchTenantsListData } from "../../../../../../hooks/useFetchTenantsListData";
import { useFetchCurrencyListData } from "../../../../../../hooks/useFetchCurrencyListData";
import { Card, message } from 'antd';
import _, { debounce, get } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import asyncRoute from '../../../../../../helpers/hoc/asyncRoute';
import {
  handleFieldError,
  handleError,
} from "../../../../../../utils/form-validation";
import { postAddThirdPartySeatAction, getProfileListAllAction, postMapDefaultSeatsAction, postCustomReportAction, postCampaignSyncStatusAction } from '../../../../../../actions';
import { accountOwnerOptions, formFields } from "./constant";
import { getInfomoViewListAction } from "../../../../../../actions/connectionManager";
import { isApiCallSuccess, scrollToElement, toTitleCase } from "../../../../../../selectors";
import { Modal, Button } from 'antd';
import InfomoResignInSeat from "../../../../../../components/SeatResignin/InfomoResignInSeat";
import { checkPermission, checkTablePermission } from "../../../../../../utils/route-auth";
import Datepicker from '../../../../../../components/FormElements/Datepicker';
import { PERMISSION } from "../../../../../../constants/permission";
import moment from "moment";
import { platformConfig } from "../../../../../../components/InfomoSeat/constant";
import { Modal as AlertMsgModal } from 'semantic-ui-react';
const Tabs = asyncRoute(() => import('../../../../../../components/Tabs'));
const InfomoSeat = asyncRoute(() => import('../../../../../../components/InfomoSeat'));
const ToastModal = asyncRoute(() => import('../../../../../../components/ToastModal'));
const Spinner = asyncRoute(() => import('../../../../../../components/Spinner'));
const SelectNew = asyncRoute(() => import('../../../../../../components/FormElements/SelectNew'));
const Input = asyncRoute(() => import('../../../../../../components/FormElements/Input'));
const BreadCrumb = asyncRoute(() => import('../../../../../../components/BreadCrumb'));
const CampaignSync = asyncRoute(() => import('../../../../../../components/CampaignSync'));

const List = (props) => {
  const platformData = useFetchPlatformData();
  const countryData = useFetchCountryListData();
  const tenantsData = useFetchTenantsListData();
  const currencyData = useFetchCurrencyListData();
  const [alertData, setAlertData] = useState([]);
  // console.log(tenantsData, "tenantsData");
  // const tenantsListOptions = tenantsData !== '' ? tenantsData.filter(item => item.tenantType.toLowerCase() == "advertiser") : [];
  const tenantsListOptions = tenantsData !== '' ? tenantsData.filter(item => item.tenantType == "Advertiser" || item.tenantType == "Demo Advertiser" || item.tenantType == "DSP/Ad network") : [];
  const platformOptions = [{ key: -1, value: 'All' }, ...platformData];
  const countryOptions = [{ id: -1, countryName: 'All' }, ...countryData];

  const infomoSeatsOptionsList = useMemo(() => {
    return (checkTablePermission({ add: PERMISSION.ADMIN.CONNECTIONMANAGEMENT.ADD, edit: PERMISSION.ADMIN.CONNECTIONMANAGEMENT.EDIT, delete: PERMISSION.ADMIN.CONNECTIONMANAGEMENT.DELETE }, {
      columns: [
        { id: 1, name: '', label: '', sortable: false },
        { id: 2, name: 's.no', label: 'S.NO', sortable: false },
        {
          id: 2, name: 'platformId', label: 'PLATFORM', sortable: true, type: 'number',
          component: row => {
            let platformValue = '';
            if (platformData && row.platformId) {
              let foundPlatform = platformData.find(plat => plat.key === row.platformId);
              if (foundPlatform) {
                platformValue = foundPlatform.value;
              }
            }
            return <>{platformValue}</>;
          }
        },
        {
          id: 3, name: 'displayName', label: 'ACCOUNT DISPLAY NAME', sortable: true, type: 'string',
          component: row => <>{row.displayName ? row.displayName : row.accountName}</>
        },
        {
          id: 4, name: 'accountName', label: 'INFOMO ACCOUNT NAME', sortable: true, type: 'string',
          component: row => <>{row.accountName ? row.accountName : row.displayName}</>
        },
        {
          id: 5, name: 'country', label: 'COUNTRY', sortable: true, type: 'string',
          component: row => {
            let countryValue = 'ALL';
            if (row.country && Array.isArray(countryData)) {
              let foundCountry = countryData.find(country => country.id == row.country);
              if (foundCountry) {
                countryValue = foundCountry.countryName;
              }
            }
            return <>{countryValue}</>;
          }
        },
        {
          id: 6, name: 'currency', label: 'CURRENCY', sortable: true, type: 'string',
        },
        {
          id: 7, name: 'noOfAdvertiserMapped', label: 'NUM OF ADVERTISERS USING', sortable: true, type: 'number',
        },
      ],
      actionsThead: true,
      actions: [
        {
          type: 'resignin',
          text: '',
          icon: 'ti ti-login color-beki',
          tooltip: '',
          iconType: 'new'
        },
        {
          type: 'edit',
          text: '',
          icon: 'ti ti-pencil color-beki',
          tooltip: 'EDIT',
          iconType: 'new'
        },
        {
          type: 'remove',
          text: '',
          icon: 'ti ti-trash color-beki',
          tooltip: 'DELETE',
          iconType: 'new'
        },
        {
          type: 'sync',
          text: '',
          icon: 'ti ti-refresh color-beki',
          tooltip: 'Sync',
          iconType: 'new'
        },
        {
          type: 'alert',
          text: '',
          icon: 'ti ti-alert-triangle color-beki',
          tooltip: 'Alert',
          iconType: 'new',
          hide: (row) => alertData.some((alert) => alert.accountId == row.accountId)
        }

      ],
      sortable: true,
      dateType: true,
      showSearch: false,
      searchable: true,
      searchColumns: [],
      defaultSortParams: {},
      paging: true,
      defaultPagingParams: {
        pageSize: 25
      },
      recActive: true,
      showSwitch: true,
      status: {
        key: 'isRecActive',
        active: '1',
        activeIcon: 'mdi mdi-checkbox-marked',
        inActiveIcon: 'mdi mdi-close-box',
        confirmation: true,
        activeConfirmationMessage: "Kindly confirm the deactivation of this record.",
        inActiveConfirmationMessage: "Please confirm if you wish to activate this record.",
        type: 'recActive'
      },
      rowsSelectiveStatus: true
    }));
  }, [platformData, alertData]);

  const advertisersConnectionOptionsList = useMemo(() => {
    return (
      checkTablePermission({ edit: PERMISSION.ADMIN.CONNECTIONMANAGEMENT.EDIT }, {
        columns: [
          { id: 1, name: '', label: '', sortable: false },
          {
            id: 2, name: 'advertiserId', label: 'ADVERTISER', sortable: false, type: 'string',
            component: row => {
              let tenantName = '';
              if (tenantsData && row.advertiserId) {
                let foundTenant = tenantsData.find(tenant => tenant.tenantId === Number(row.advertiserId));
                if (foundTenant) {
                  tenantName = foundTenant.tenantName;
                }
              }
              return <>{tenantName}</>;
            }
          },
          {
            id: 3, name: 'agencyId', label: 'AGENCY', sortable: false, type: 'string',
            component: row => {
              let parentTenantName = '';
              if (tenantsData && row.advertiserId) {
                let foundTenant = tenantsData.find(tenant => tenant.tenantId === Number(row.advertiserId));
                if (foundTenant) {
                  parentTenantName = foundTenant.parentTenantName;
                }
              }
              return <>{parentTenantName}</>;
            }
          },
          {
            id: 4, name: 'platformId', label: 'PLATFORM', sortable: true, type: 'number',
            component: row => {
              let platformValue = '';
              if (platformData && row.platformId) {
                let foundPlatform = platformData.find(plat => plat.key === row.platformId);
                if (foundPlatform) {
                  platformValue = foundPlatform.value;
                }
              }
              return <>{platformValue}</>;
            }
          },
          {
            id: 5, name: 'displayName', label: 'DISPLAY ACCOUNT NAME', sortable: true, type: 'string', component: row => row.displayName ? row.displayName : row.accountName
          },
          {
            id: 6, name: 'accountOwner', label: 'ACCOUNT OWNER', sortable: true, type: 'string',
            component: row => {
              return <>{row.seatType == 0 ? 'Infomo' : row.seatType == 1 ? 'Agency' : 'Advertiser'}</>;
            }
          },
          {
            id: 7, name: 'currency', label: 'CURRENCY', sortable: true, type: 'string'
          }
        ],
        actionsThead: true,
        actions: [
          {
            type: 'sync',
            text: '',
            icon: 'ti ti-refresh color-beki',
            tooltip: 'Sync',
            iconType: 'new'
          }, {
            type: 'alert',
            text: '',
            icon: 'ti ti-alert-triangle color-beki',
            tooltip: 'Alert',
            iconType: 'new',
            hide: (row) => alertData.some((alert) => alert.accountId == row.accountId && alert.advertiserId && alert.advertiserId == row.advertiserId)

          }
        ],
        sortable: true,
        dateType: true,
        showSearch: false,
        searchable: true,
        searchColumns: [],
        defaultSortParams: {},
        paging: true,
        defaultPagingParams: {
          pageSize: 25
        },
        recActive: true,
        showSwitch: true,
        status: {
          key: 'isRecActive',
          active: '1',
          activeIcon: 'ti ti-toggle-left color-beki ti-lg',
          inActiveIcon: 'ti ti-toggle-right color-beki ti-lg',
          confirmation: true,
          activeConfirmationMessage: "Kindly confirm the deactivation of this record.",
          inActiveConfirmationMessage: "Please confirm if you wish to activate this record.",
          type: 'recActive'
        }
      })
    )
  }, [tenantsData, platformData, alertData]);
  const alertOptions = {
    columns: [
      { id: 1, name: '', label: '', sortable: false, },
      { id: 2, name: 'accountId', label: 'ACCOUNT', sortable: false, type: 'string' },
      { id: 3, name: 'campaignId', label: 'CAMPAIGN', sortable: false, type: 'string' },
      { id: 4, name: 'status', label: 'STATUS ', sortable: false, type: 'string' }
    ],
    keyCol: 'aId',
    actions: [],
    recActive: false,
    showSwitch: false,
    actionsThead: false,
    sortable: false,
    dateType: false,
    defaultSortParams: {},
    showSearch: false,
    searchable: true,
    searchColumns: [],
    paging: false
  };

  const modalType = {
    infomoSeatUpdated: 'infomoSeatUpdated',
    seatMappingUpdated: 'seatMappingUpdated',
    infomoSeatDeleted: 'infomoSeatDeleted'
  };

  const [infomoSeats, setInfomoSeats] = useState([]);
  const [advertisersConnectionList, setAdvertisersConnectionList] = useState([]);
  const [newSeat, setNewSeat] = useState(false);
  const [campaignSyncVisible, setCampaignSyncVisible] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [seatConfigurationData, setSeatConfigurationData] = useState([]);
  const [agencyOptions, setAgencyOptions] = useState([]);
  const [advertiserOptions, setAdvertiserOptions] = useState([]);
  const [campaignSyncAdvertisersList, setCampaignSyncAdvertisersList] = useState([]);
  const [infomoSeatEditId, setInfomoSeatEditId] = useState(null);
  const [modalCallback, setModalCallback] = useState('');
  const [searchInputFocused, setSearchInputFocused] = useState(false);
  const [deletionModal, setDeletionModal] = useState(false);
  const [customReportModal, setCustomReportModal] = useState(false);
  const [recordToBeDeleted, setRecordToBeDeleted] = useState(null);
  const [seatResiginIn, setSeatResignIn] = useState(false);
  const [resignInSeatData, setResignInSeatData] = useState(null);
  const [selectedCampaignSyncAccount, setSelectedCampaignSyncAccount] = useState({});
  const [isSelectDefaultAdvertiser, setIsSelectDefaultAdvertiser] = useState(false);
  const [alertModal, setAlertModal] = useState(false);
  const [selectedSeatinfo, setSelectedSeatinfo] = useState([]);
  const accountIdsRef = useRef([]);
  const [selectSeatId, setSelectSeatId] = useState(null);
  const [showData, setShowData] = useState([])

  const [toastModal, setToastModal] = useState({
    enableToast: false,
    toastStatus: "",
    toastMsg: ""
  });
  const [popoverVisible, setPopoverVisible] = useState(false);
  const [advertisersConnectionPopover, setAdvertisersConnectionPopover] = useState(false);

  const [form, setForm] = useState({
    countryFilter: -1,
    platformFilter: -1,
    platformCloneFilter: -1,
    accountOwnerFilter: -1
  });
  const [agencyFilter, setAgencyFilter] = useState(-1);
  const [advertiserFilter, setAdvertiserFilter] = useState(-1);

  const [touched, setTouched] = useState({});
  const [errors, setErrors] = useState({});
  const [submited, setSubmited] = useState(false);

  const userId = useSelector((state) => get(state, "app.preSignInData.userId", ""));
  const authToken = useSelector((state) => get(state, "app.signInData.authToken", ""));
  const tenantId = useSelector((state) => get(state, "app.preSignInState.tenantId", ""));
  const platformConfiguration = useSelector(state => get(state, 'app.platformConfiguration', {}));

  const dispatch = useDispatch();

  const getInfomoSeatsData = async () => {
    try {
      let params = { list: 'all' };
      let payload = {};
      payload = {
        thirdPartySeatRequest: {
          filters: {
            countryIds: Number(form.countryFilter) != -1 ? [Number(form.countryFilter)] : [],
            platformId: Number(form.platformFilter) != -1 ? [Number(form.platformFilter)] : []
          }
        }
      };
      await dispatch(getInfomoViewListAction({ tenantId, authToken, userId, params, payload }))
        .then((data) => {
          const { responseCode: { status }, response } = data;
          // console.log(response);
          if (status.toLowerCase() == "success" && response && response.length > 0) {
            // let dummy = response.map((seat, index) => {
            //   if (index % 2 == 0) {
            //     seat.isExpired = true;
            //   } else {
            //     seat.isExpired = false;
            //   }
            //   return seat;
            // });
            const processedResponse = response.map(item => {
              item.isDisabled = item.isExpired;
              item.disabledActions = item.isExpired ? ['ti ti-pencil color-beki'] : [];
              item.showStatusSwitch = !item.isExpired;
              return item;
            });
            setInfomoSeats(processedResponse);
            //setInfomoSeats(prev => [...prev, ...processedResponse]);
          } else {
            setInfomoSeats([]);
          }
        }).catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const getAdvertisersConnectionList = async () => {
    try {
      let params = { list: 'mapped' };
      let payload = {};
      let filters = {};
      if (agencyFilter != -1) {
        filters.agencyIds = [agencyFilter];
      }
      if (advertiserFilter != -1 && advertiserFilter != '') {
        filters.advertiserIds = [advertiserFilter];
      }
      if (form.platformCloneFilter != -1) {
        filters.platformId = [Number(form.platformCloneFilter)];
      }
      if (form.accountOwnerFilter != -1) {
        filters.seatTypes = [Number(form.accountOwnerFilter)];
      }
      if (Object.keys(filters).length > 0) {
        payload = {
          thirdPartySeatRequest: {
            filters: filters
          }
        };
      }
      await dispatch(getInfomoViewListAction({ tenantId, authToken, userId, params, payload }))
        .then((data) => {
          const { responseCode: { status }, response } = data;
          if (status.toLowerCase() == "success" && response && response.length > 0) {
            let processedResponse = response.map(item => ({ ...item, action: item.seatType == 0 ? true : false }));
            setAdvertisersConnectionList(processedResponse);
            // console.log(response, 'RESPONSE');
          } else {
            console.log("Infomo mapped seats not found!");
            setAdvertisersConnectionList([]);
          }
        }).catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const checkCustomReportData = () => {
    try {
      // if (resignInSeatData) {
      //   setCustomReportModal(true);
      // }
    } catch (error) {
      console.log(error);
      setCustomReportModal(false);
    }
  };

  const resetAdvertiserConnectionFilters = () => {
    try {
      setForm({ ...form, platformCloneFilter: -1, accountOwnerFilter: -1 });
      setAgencyAndAdvertiserOptions();
      setAgencyFilter(-1);
      setAdvertiserFilter(-1);
    } catch (error) {
      console.log(error);
    }
  };

  const searchAdvertisersConnectionList = async (searchParam = "") => {
    try {
      let params = { list: 'mapped' };
      let payload = {
        thirdPartySeatRequest: {
          filters: {
            searchString: searchParam
          }
        }
      };

      if (searchParam.trim().length > 0) {
        await dispatch(getInfomoViewListAction({ tenantId, authToken, userId, params, payload }))
          .then((data) => {
            const { responseCode: { status }, response } = data;
            if (isApiCallSuccess(status) && response && response.length > 0) {
              console.log(response, 'RESPONSE');
              setAdvertisersConnectionList(response);
            } else {
              setAdvertisersConnectionList([]);
              console.log("Infomo mapped seats not found!");
            }
          }).catch((error) => {
            console.error(error);
          });
      }
      else {
        getAdvertisersConnectionList()
      }

    } catch (error) {
      console.log(error);
    }
  };

  const setAgencyAndAdvertiserOptions = () => {
    try {
      let agencyList = tenantsData.filter(item => item.tenantType.toLowerCase() === "dsp/ad network" || item.tenantType.toLowerCase() === "advertiser & dsp/ad network");
      agencyList = agencyList.map(item => ({ ...item, key: item.tenantId, value: item.tenantName }));
      agencyList = [{ key: -1, value: 'All' }, ...agencyList];
      let advertiserList = tenantsData.filter(item => item.tenantType.toLowerCase() === "advertiser" || item.tenantType.toLowerCase() === "demo advertiser");
      advertiserList = advertiserList.map(item => ({ ...item, key: item.tenantId, value: item.tenantName, advertiserId: item.tenantId, advertiserName: item.tenantName }));
      setCampaignSyncAdvertisersList(advertiserList);
      advertiserList = [{ key: -1, value: 'All' }, ...advertiserList];
      setAdvertiserOptions(advertiserList);
      setAgencyOptions(agencyList);
    } catch (error) {
      console.log(error);
    }
  }

  const getDefaultSeatConfigurationData = async () => {
    try {
      let params = { list: 'default' };
      await dispatch(getInfomoViewListAction({ tenantId, authToken, userId, params }))
        .then((data) => {
          const { responseCode: { status }, response } = data;
          if (status.toLowerCase() == "success" && response && response.length > 0) {
            setSeatConfigurationData(response);
          } else {
            console.log("Users mapped seats not found!");
          }
        }).catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const getAdvertisersListAgencyData = async (id) => {
    try {
      let list;
      await dispatch(getProfileListAllAction({ tenantId: id, authToken, userId }))
        .then((data) => {
          const { responseCode: { status }, response } = data;
          if (status.toLowerCase() == "success") {
            list = response;
          } else {
            console.log("Users mapped seats not found!");
          }
        }).catch((error) => {
          console.error(error);
        });
      return list;
    } catch (error) {
      console.log(error);
    }
  };

  const handleInfomoSeatStatus = async (row) => {
    try {
      let params = { addup: row.id };
      let payload = {
        thirdPartySeatRequest: {
          ...row,
          isRecActive: row.isRecActive == 1 ? 0 : 1
        }
      };
      await dispatch(getInfomoViewListAction({ tenantId, authToken, userId, params, payload }))
        .then((data) => {
          const { responseCode: { msg, status = '' }, responseObj } = data;
          if (status.toLowerCase() == "success") {
            // console.log(responseObj);
            setModalCallback(modalType.infomoSeatUpdated);
            toast(status, msg);
          }
        }).catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleMappedSeatStatus = async (row) => {
    try {
      let params = { addup: row.id };
      let payload = {
        thirdPartySeatRequest: {
          ...row,
          isRecActive: row.isRecActive == 1 ? 0 : 1
        }
      };
      await dispatch(getInfomoViewListAction({ tenantId, authToken, userId, params, payload }))
        .then((data) => {
          const { responseCode: { msg, status = '' }, responseObj } = data;
          if (status.toLowerCase() == "success") {
            // console.log(responseObj);
            setModalCallback(modalType.seatMappingUpdated);
            toast(status, msg);
          }
        }).catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const removeSeat = async (consent) => {
    try {
      let params = { map: 'remove' };
      let payload = {
        thirdPartySeatRequest: {
          accountId: recordToBeDeleted.accountId,
          consent
        }
      };
      if (recordToBeDeleted) {
        await dispatch(postMapDefaultSeatsAction({ tenantId, authToken, userId, params, payload }))
          .then((data) => {
            const { responseCode: { msg, status = '' }, responseObj } = data;
            if (isApiCallSuccess(status)) {
              setModalCallback(modalType.infomoSeatDeleted);
              toast(status, msg);
            } else {
              toast(status, msg);
            }
          }).catch((error) => {
            console.error(error);
          });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const customReportSubmit = async () => {
    try {
      let params = { addup: 'auto' };
      let payload = {
        reportRequest: {
          accountId: resignInSeatData.accountId,
          startDate: moment(form.startDate).format("YYYY-MM-DD"),
          endDate: moment(form.endDate).format("YYYY-MM-DD"),
          platformId: resignInSeatData.platformId
        }
      };
      await dispatch(postCustomReportAction({ tenantId, authToken, userId, params, payload }))
        .then((data) => {
          const { responseCode: { msg, status = '' }, responseObj } = data;
          if (isApiCallSuccess(status)) {
            setModalCallback(modalType.infomoSeatDeleted);
            toast(status, msg);
          } else {
            toast(status, msg);
          }
        }).catch((error) => {
          console.error(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (e) => {
    try {
      const { name, value } = e.target;
      const newForm = { ...form };
      newForm[name] = value;
      if (name == 'search') {
        setSearchInputFocused(true);
        debouncedSearch(value);
        return;
      }
      setForm(newForm);
    } catch (error) {
      console.log(error);
    }
  };

  const handleTouch = (e) => {
    try {
      const newTouched = { ...touched };
      const newErrors = { ...errors };
      const { error } = handleFieldError(e.target.value, formFields[e.target.name]);
      newErrors[e.target.name] = error;
      newTouched[e.target.name] = true;
      setTouched(newTouched);
      setErrors(newErrors);
    } catch (error) {
      console.log(error);
    }
  };

  const showLoading = (spinner) => {
    setShowSpinner(spinner);
  };

  const mapNewSeat = () => {
    try {
      setInfomoSeatEditId(null);
      if (campaignSyncVisible) {
        setNewSeat(true);
        setCampaignSyncVisible(false);
      } else {
        setNewSeat(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const togglePopover = () => {
    setPopoverVisible(!popoverVisible);
  };

  const handleAgencyFilterChange = async () => {
    try {
      if (tenantsData !== '') {
        if (agencyFilter == -1) {
          let advertiserList = tenantsData.filter(item => item.tenantType.toLowerCase() === "advertiser");
          advertiserList = advertiserList.map(item => ({ ...item, key: item.tenantId, value: item.tenantName }));
          advertiserList = [{ key: -1, value: 'All' }, ...advertiserList];
          setAdvertiserOptions(advertiserList);
        } else {
          let tenantsListOptions = await getAdvertisersListAgencyData(agencyFilter);
          if (Array.isArray(tenantsListOptions)) {
            tenantsListOptions = tenantsListOptions.map(item => ({ ...item, key: item.advertiserId, value: item.advertiserName }));
            setAdvertiserOptions(tenantsListOptions);
            setAdvertiserFilter('');
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  const mapPageState = () => {
    const data = JSON.parse(localStorage.getItem('connectionManagementPage'));
    if (data) {
      if (data.hasOwnProperty('newSeat'))
        setNewSeat(true);
      else {
        setSeatResignIn(true);
        setResignInSeatData(data['resignInSeatData']);
        setInfomoSeatEditId(null);
      }
    }
  };

  useEffect(() => {
    getInfomoSeatsData();
    getAdvertisersConnectionList();
    getDefaultSeatConfigurationData();
    mapPageState();
  }, []);

  useEffect(() => {
    if (tenantsData !== '') {
      setAgencyAndAdvertiserOptions();
    }
  }, [tenantsData]);

  useEffect(() => {
    handleAgencyFilterChange();
  }, [agencyFilter]);

  const debouncedSearch = debounce((searchParam) => {
    searchAdvertisersConnectionList(searchParam)
  }, 800);

  // useEffect(() => {
  //   if (searchParams && searchParams.length > 3) {
  //     debouncedSearch();
  //     // clearTimeout(searchTimeout);
  //     // setSearchTimeout(setTimeout(() => searchAdvertisersConnectionList(), 300));
  //   }
  // }, [searchParams]);
  useEffect(() => {
    let intervalId;
    const resetInterval = () => {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    };


    // Check if infomoSeats has some length
    if (infomoSeats && infomoSeats.length > 0) {
      // Update the ref with the latest accountIds
      accountIdsRef.current = infomoSeats.map((item) => item.accountId);
      if (!intervalId) {
        console.log("Running immediately for the first time.");
        checkSyncedCampaignData(accountIdsRef.current);

        // Set the interval for after executions
        intervalId = setInterval(() => {
          checkSyncedCampaignData(accountIdsRef.current); // Use the latest accountIds
        }, 15000);
      }
    } else {
      // if infomoSeats is empty
      resetInterval();
    }

    return () => {
      resetInterval();
    };
  }, [infomoSeats]);



  const getCampaignSyncListParams = (platformId) => {
    let platform = platformData.find(platform => platform.key == platformId);
    platform = platform.value;
    if (platform.toLowerCase() == 'google ads') {
      return { param: 'ads' };
    } else if (platform.toLowerCase() == 'dv360') {
      return { param: 'dv360' };
    } else if (platform.toLowerCase() == 'tiktok') {
      return { param: 'ads' };
    } else if (platform.toLowerCase() == 'meta') {
      return { param: 'fb' };
    } else {
      return { param: '', requestBodyKey: '' };
    }
  };
  //??
  const checkSyncedCampaignData = async () => {

    //const { param } = getCampaignSyncListParams(selectedCampaignSyncAccount.platformId);
    const accountId = selectedSeatinfo.accountId || "";
    let payload = {
      syncStatus: {
        tenantId
      }
    };

    // Conditionally add accountId to payload if it exists
    // if (accountId) {
    //   payload.syncStatus.accountId = accountId;
    // }


    await dispatch(postCampaignSyncStatusAction({ tenantId, authToken, userId, payload }))
      .then((data) => {
        const { responseCode: { status = '', msg }, responseObj } = data;
        console.log("Data", data);

        if (status && status === "Success") {
          try {
            // Parse responseObj
            const parsedResponseObj = JSON.parse(responseObj);

            // Extract and transform data
            const statusData = Object.entries(parsedResponseObj).flatMap(([accountId, advertiserData]) =>
              advertiserData.flatMap((advertiserStr) => {
                const parsedAdvertiser = JSON.parse(advertiserStr); // Parse advertiser string
                return Object.entries(parsedAdvertiser).flatMap(([advertiserOrCampaignId, campaignData]) => {
                  // Check if the key contains campaign data
                  if (typeof campaignData === 'object') {
                    return Object.entries(campaignData).map(([campaignAccountId, campaigns]) => ({
                      accountId: Number(campaignAccountId),
                      advertiserId: advertiserOrCampaignId.match(/^\d+$/) ? advertiserOrCampaignId : "",
                      campaigns: Object.entries(campaigns).map(([campaignId, status]) => ({
                        accountId: Number(campaignAccountId),
                        campaignId: Number(campaignId),
                        status: status,
                      })),
                    }));
                  } else {
                    return {
                      accountId: Number(accountId),
                      advertiserId: "",
                      campaigns: [
                        {
                          accountId: Number(accountId),
                          campaignId: Number(advertiserOrCampaignId),
                          status: campaignData,
                        },
                      ],
                    };
                  }
                });
              })
            );

            console.log("Transformed Data:", statusData);
            setAlertData(statusData);
          } catch (error) {
            console.error("Error parsing responseObj:", error);
          }


        }
      })
      .catch((error) => {
        console.error("API call failed:", error);
      });


  }
  useEffect(() => {
    // Additional condition to call getAlertData
    if (selectSeatId && alertData.length > 0) {
      getAlertData(selectSeatId); // Call the function if conditions are met
    }
  }, [alertData, selectSeatId]); // Added dependencies for a complete effect

  // useEffect(() => {
  //   // Calculate the result
  //   const result = accountIdsRef.current.map((accountId) => {
  //     const isPresent = alertData.some((alert) => alert.accountId == accountId); // Check if accountId exists in alerData
  //     return { [accountId]: isPresent };
  //   });
  //   // Log or set the result if needed (e.g., update a state)
  //   console.log("Result:", accountIdsRef.current, result);
  //   Object,keys(result).includes(row.id)
  // }, [alertData]);

  const getAlertData = (accIds) => {
    const data = alertData.filter((alert) => accIds.includes(alert.accountId)).flatMap((alert) => alert.campaigns);
    setShowData(data);
  }

  const isPlatformSyncSupported = (platformId) => {
    const campaignSyncSupportedPlatforms = [platformConfig.meta, platformConfig.google, platformConfig.dv360];
    const platform = platformData.find(platform => platform.platformId == platformId);
    return campaignSyncSupportedPlatforms.includes(platform.value);
  };

  const handleAction = (row, action) => {
    const { match, history } = props;
    if (action.type === 'recActive') {
      handleInfomoSeatStatus(row);
    } else if (action.type === 'edit') {
      scrollToElement('infomoSeat');
      setNewSeat(true);
      setInfomoSeatEditId(row.id);
      setResignInSeatData(null);
    } else if (action.type === 'remove') {
      setRecordToBeDeleted(row);
      setDeletionModal(true);
    } else if (action.type === 'sync') {
      if (isPlatformSyncSupported(row.platformId)) {
        setIsSelectDefaultAdvertiser(false);
        setSelectedCampaignSyncAccount(row);
        scrollToElement('infomoCampaignSync');
        setCampaignSyncVisible(true);
        setNewSeat(false);
      } else {
        message.error('The selected account platform does not support campaign syncing!');
      }
    } else if (action.type === "alert") {
      console.log("Row", row);
      setSelectSeatId(row.accountId);
      getAlertData(row.accountId);
      setSelectedSeatinfo(row)
      setAlertModal(true);
    }
    else if (action.type === 'resignin') {
      scrollToElement('infomoResignIn');
      setNewSeat(false);
      setSeatResignIn(true);
      setResignInSeatData(row);
      setInfomoSeatEditId(row.id);
    }
  };

  const handleAdvertisersConnectionAction = (row, action) => {
    if (action.type === 'recActive') {
      handleMappedSeatStatus(row);
    } else if (action.type === 'sync') {
      scrollToElement('infomoCampaignSync');
      setIsSelectDefaultAdvertiser(true);
      setCampaignSyncVisible(true);
      setNewSeat(false);
      setSelectedCampaignSyncAccount(row);
    }
    else if (action.type === "alert") {
      setSelectSeatId(row.accountId);
      getAlertData(row.accountId);
      setSelectedSeatinfo(row)
      setAlertModal(true);
    }
  };

  const toast = (status, msg, type) => {
    setToastModal({
      enableToast: true,
      toastStatus: status,
      toastMsg: msg
    });
    return;
  }

  const handleToastStatus = async (status) => {
    setToastModal({
      ...toastModal,
      enableToast: status
    });
    if (modalCallback == modalType.infomoSeatUpdated) {
      getInfomoSeatsData();
    } else if (modalCallback == modalType.seatMappingUpdated) {
      getAdvertisersConnectionList();
    } else if (modalCallback == modalType.infomoSeatDeleted) {
      getInfomoSeatsData();
      getAdvertisersConnectionList();
    } else {

    }
    setModalCallback('');
  };

  const confirmationCallbackModel = (id) => {
    setToastModal({
      ...toastModal,
      enableToast: false
    });
  };

  const preservePageState = (data, type = 'newSeat') => {
    let store = { ...data };
    if (type == 'newSeat')
      store = { ...store, newSeat: newSeat };
    else
      store = { ...store, resignInSeatData: resignInSeatData };
    localStorage.setItem('connectionManagementPage', JSON.stringify(store));
  };

  return (
    <>
      {showSpinner || tenantsListOptions.length == 0 && <Spinner />}
      {
        toastModal.enableToast && <ToastModal
          enableToast={toastModal.enableToast}
          status={toastModal.toastStatus}
          msg={toastModal.toastMsg}
          // path={routes.containers.admin + '/' + routes.admin.account.name}
          poc={true}
          idProps={props}
          handleConfirmation={confirmationCallbackModel}
          handleToastStatus={handleToastStatus}
          confirmationMsg={toastModal.toastMsg}
          outSideClickEnable={false}
        />
      }
      <Modal
        title="Seat Deletion"
        style={{ fontFamily: "Poppins" }}
        visible={deletionModal}
        onCancel={() => setDeletionModal(false)}
        centered
        footer={[
          <Button key="submit" type="primary" onClick={() => {
            setDeletionModal(false);
            removeSeat(1);
          }}>
            Delete Seat & Pause Campaign
          </Button>,
          <Button key="submit" type="danger" onClick={() => {
            setDeletionModal(false);
            removeSeat(0);
          }}>
            Delete Seat
          </Button>,
          <Button key="back" type="danger" onClick={() => {
            setDeletionModal(false);
            setRecordToBeDeleted(null);
          }}>
            Cancel
          </Button>
        ]}
      >
        <p style={{ fontFamily: "Poppins" }}>
          Upon deletion of the seat, all data associated with the Advertiser and the seat (Campaign List, Dashboard, History of Recommendations, etc.) will be permanently removed from {toTitleCase(platformConfiguration['name'])} screens. No new data will be retrieved, and no further activity can be performed on the current data following confirmation.
          <br /> <br />
          <strong>Pause Campaigns</strong>
          <p>You have the option to pause campaigns on third-party platforms. Kindly let us know your decision.</p>
          <br />
        </p>
      </Modal>

      <Modal
        title="Custom Report Pull Request"
        style={{ fontFamily: "Poppins" }}
        visible={customReportModal}
        onCancel={() => setCustomReportModal(false)}
        centered
        footer={[
          <Button key="submit" type="primary" onClick={async () => {
            await customReportSubmit();
            setCustomReportModal(false);
          }}>
            Submit
          </Button>,
          <Button key="back" type="danger" onClick={() => {
            setCustomReportModal(false);
          }}>
            Cancel
          </Button>
        ]}
      >
        <>
          <p>Resync the seat data since it has expired select start date and end date to sync dashboard.</p>
          <div className="d-flex">
            <div className="col-md-6 p-0">
              <Datepicker
                onChange={handleChange}
                onBlur={handleTouch}
                value={form[formFields.startDate.key] || ''}
                setting={formFields[formFields.startDate.key]}
                error={errors[formFields.startDate.key]}
                submited={submited}
                touched={touched[formFields.startDate.key]}
                minDate={moment().subtract(7, 'days').toDate()}
                maxDate={moment().toDate()}
              />
            </div>

            <div className="col-md-6">
              <Datepicker
                onChange={handleChange}
                onBlur={handleTouch}
                value={form[formFields.endDate.key] || ''}
                setting={formFields[formFields.endDate.key]}
                error={errors[formFields.endDate.key]}
                submited={submited}
                touched={touched[formFields.endDate.key]}
                minDate={moment().subtract(7, 'days').toDate()}
                maxDate={moment().toDate()}
              />
            </div>
          </div>
        </>
      </Modal>

      {/* Alert Modal */}
      <AlertMsgModal open={alertModal} onClose={() => {
        setAlertModal(false);
      }} size='fullscreen' >
        <div className='form__style' style={{ width: '100%', height: '100%', background: '#F7F8FC', boxShadow: '0px 20px 70px rgba(0, 0, 0, 0.25)', borderRadius: 10, flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', display: 'inline-flex' }}>
          <div style={{ alignSelf: 'stretch', height: 76, flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 10, display: 'flex' }}>
            <div style={{ alignSelf: 'stretch', padding: 20, justifyContent: 'space-between', alignItems: 'center', display: 'inline-flex' }}>
              <div style={{ width: 20, height: 20, position: 'relative', background: 'rgba(255, 255, 255, 0)' }} />
              <div style={{ color: '#040B1B', fontSize: 24, fontWeight: '500', wordWrap: 'break-word' }}>Alert Message</div>
              <div style={{ width: 20, height: 20, position: 'relative', top: '-10px' }}>
                <button type="button" onClick={() => {
                  setAlertModal(false);

                }} className="close" data-dismiss="modal" aria-label="Close">
                  <div className="modal-title modal-colse modal-cross" ><span aria-hidden="true">×</span></div>
                </button>
              </div>
            </div>
          </div>

          <div className='m-4'>
            <AlertMsgModal.Content scrolling>
              <div className='campaign-adj mb-4'>
                <div className="campaign-list-adj table-responsive camapignSyncError">
                  {/* Need to be change */}
                  {/* {console.log("platformSeatAlertData", platformSeatAlertData)} */}
                  <Table
                    options={alertOptions}
                    data={showData}
                  />

                </div>
              </div>


            </AlertMsgModal.Content>
          </div>

        </div>
      </AlertMsgModal>

      <div className="main-panel ion form__style">
        <div className="content-wrapper">
          <BreadCrumb />
          <div className="row mt-3">
            {/* <Card>

                <Tabs container="admin" />
              </Card> */}
            <Tabs container="admin" />
            <Card style={{ marginLeft: 20, marginRight: 20 }}>
              <div className='d-flex align-items-center justify-content-between mb-2' id="infomoSeat">
                <div className='d-flex align-items-center position-relative'>
                  <button style={{ height: 35, border: "1px solid #303890", color: "#303890", background: "#fff", marginBottom: 10, borderRadius: 6 }} className='btn' onClick={togglePopover}>
                    <i className='ti ti-filter ti-sm'></i>
                    Filters
                  </button>
                  {popoverVisible && (
                    <div className='popover' style={{ zIndex: 100 }}>

                      <div style={{ background: "#F7F8FC" }} className='d-flex justify-content-between align-items-center p-3'>
                        <h5 style={{ fontWeight: 500, margin: 0 }}>Filters</h5>
                        <button className='close close-popover' onClick={togglePopover}>
                          &times;
                        </button>
                      </div>

                      <div className='row flex-column p-3'>
                        <div className='col-md-12 mb-2'>
                          <label>Country </label>
                          <SelectNew
                            onChange={handleChange}
                            onBlur={handleTouch}
                            value={form[formFields.countryFilter.key]}
                            setting={formFields[formFields.countryFilter.key]}
                            error={errors[formFields.countryFilter.key]}
                            submited={submited}
                            touched={touched[formFields.countryFilter.key]}
                            options={countryOptions}
                          />
                        </div>
                        <div className='col-md-12 mb-2'>
                          <label className="mr-2">Platform </label>
                          <SelectNew
                            onChange={handleChange}
                            onBlur={handleTouch}
                            value={form[formFields.platformFilter.key]}
                            setting={formFields[formFields.platformFilter.key]}
                            error={errors[formFields.platformFilter.key]}
                            submited={submited}
                            touched={touched[formFields.platformFilter.key]}
                            options={platformOptions}
                          />
                        </div>
                        <div className="col-md-12 mt-4 justify-content-end d-flex">
                          <button onClick={() => setForm({ ...form, countryFilter: -1, platformFilter: -1 })} className="btn btn-outline-primary">
                            Reset
                          </button>
                          <button onClick={() => {
                            getInfomoSeatsData();
                            togglePopover();
                          }} className="btn btn-primary bg-color-beki ml-3">
                            Apply
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {
                  !newSeat && checkPermission({
                    permissions: [PERMISSION.ADMIN.CONNECTIONMANAGEMENT.ADD]
                  }) &&
                  <div className="mt-2 p-0 d-flex justify-content-end">
                    <button onClick={() => mapNewSeat()} className="btn btn-primary rounded-2" style={{ backgroundColor: '#383890', padding: '0.625rem 1.125rem' }}>
                      <i style={{ fontSize: 18 }} className='ti ti-plus text-white' />
                      <span className="text-white" style={{ fontSize: 14 }}>New Infomo Seat</span>
                    </button>
                  </div>
                }
              </div>

              <div className="mt-3">
                {
                  newSeat ?
                    <InfomoSeat
                      onClose={() => setNewSeat(false)}
                      onSave={() => {
                        setNewSeat(false);
                        getInfomoSeatsData();
                        getAdvertisersConnectionList();
                      }}
                      props={props}
                      preservePageState={preservePageState}
                      showLoading={showLoading}
                      advertisersList={tenantsListOptions}
                      seatConfigurationData={seatConfigurationData}
                      editId={infomoSeatEditId}
                    />
                    :
                    null
                }

                <div id="infomoCampaignSync">
                  {campaignSyncVisible &&
                    <CampaignSync
                      selectedCampaignSyncAccount={selectedCampaignSyncAccount}
                      onClose={() => setCampaignSyncVisible(false)}
                      onSave={() => {
                        setCampaignSyncVisible(false);
                        // getAgenciesConnectionList();
                      }}
                      alertModal={false}
                      isAdvertisers={true}
                      createdTenantId={tenantId}
                      props={props}
                      advertisersList={campaignSyncAdvertisersList}
                      isSelectDefaultAdvertiser={isSelectDefaultAdvertiser}
                    />
                  }
                </div>

                {
                  (seatResiginIn && !newSeat) ?
                    <div id='infomoResignIn'>
                      <InfomoResignInSeat
                        onClose={() => setSeatResignIn(false)}
                        onSave={() => {
                          getInfomoSeatsData();
                          getAdvertisersConnectionList();
                          setSeatResignIn(false);
                          checkCustomReportData();
                        }} props={props}
                        preservePageState={preservePageState}
                        showLoading={showLoading}
                        advertisersList={tenantsListOptions}
                        editId={infomoSeatEditId}
                        resignInSeatData={resignInSeatData}
                      />
                    </div>
                    :
                    null
                }
              </div>

              <div className='campaign-adj'
              // style={{ height: infomoSeats.length > 10 ? "350px" : "auto", overflowY: infomoSeats.length > 10 ? "scroll" : "auto" }}
              >
                <div className="campaign-list-adj table-responsive">
                  <Table
                    options={infomoSeatsOptionsList}
                    data={infomoSeats || []}
                    handelAction={handleAction}
                  />
                </div>
              </div>

              <div className="mt-3">
                <div class="accordion mt-3 accordion-bordered details-accordion" id="accordionStyle1">
                  <div class="accordion-item card mb-0 border">
                    <h2 class="accordion-header">
                      <button type="button" className={Array.isArray(infomoSeats) && infomoSeats.length < 10 ? "accordion-button" : "accordion-button collapsed"} data-bs-toggle="collapse" data-bs-target="#accordionStyle1-1" aria-expanded={Array.isArray(infomoSeats) && infomoSeats.length != 0 && infomoSeats.length < 10 ? "true" : "false"}>
                        <div style={{ color: '#040B1B', fontSize: 16, fontFamily: 'Poppins' }} class="fw-bold fs-5">Advertisers Connection List</div>
                      </button>
                    </h2>

                    <div id="accordionStyle1-1" className={Array.isArray(infomoSeats) && infomoSeats.length < 10 ? "accordion-collapse collapse show" : "accordion-collapse collapse"} data-bs-parent="#accordionStyle1">
                      <div class="accordion-body">
                        <div className='d-flex align-items-center justify-content-between'>
                          <div className='d-flex align-items-center position-relative'>
                            <button style={{ height: 35, border: "1px solid #303890", color: "#303890", background: "#fff", marginBottom: 10, borderRadius: 6 }} className='btn' onClick={() => setAdvertisersConnectionPopover(!advertisersConnectionPopover)}>
                              <i className='ti ti-filter ti-sm'></i>
                              Filters
                            </button>
                            <div className='d-flex align-items-center mt-2 ml-3 search-adj'>
                              <i style={{ color: "#A4ABB5", fontSize: 12 }} className='ti ti-search ti-sm'></i>
                              <Input
                                onChange={handleChange}
                                onBlur={handleTouch}
                                value={form[formFields.search.key]}
                                setting={formFields[formFields.search.key]}
                                error={errors[formFields.search.key]}
                                submited={submited}
                                // disabled={true}
                                touched={touched[formFields.search.key]} />
                            </div>
                            {advertisersConnectionPopover && (
                              <div className='popover' style={{ zIndex: 100 }}>

                                <div style={{ background: "#F7F8FC" }} className='d-flex justify-content-between align-items-center p-3'>
                                  <h5 style={{ fontWeight: 500, margin: 0 }}>Filters</h5>
                                  <button className='close close-popover' onClick={() => { setAdvertisersConnectionPopover(!advertisersConnectionPopover) }}>
                                    &times;
                                  </button>
                                </div>

                                <div className='row flex-column p-3'>
                                  <div className='col-md-12 mb-2'>
                                    <label className="mb-2">Agency</label>
                                    <SelectNew
                                      onChange={(e) => setAgencyFilter(Number(e.target.value))}
                                      onBlur={handleTouch}
                                      value={agencyFilter}
                                      setting={formFields[formFields.agencyFilter.key]}
                                      error={errors[formFields.agencyFilter.key]}
                                      submited={submited}
                                      touched={touched[formFields.agencyFilter.key]}
                                      options={agencyOptions}
                                    />
                                  </div>
                                  <div className='col-md-12 mb-2'>
                                    <label className="mr-2 mb-2">Advertiser</label>
                                    <SelectNew
                                      onChange={(e) => setAdvertiserFilter(Number(e.target.value))}
                                      onBlur={handleTouch}
                                      value={advertiserFilter}
                                      setting={formFields[formFields.advertiserFilter.key]}
                                      error={errors[formFields.advertiserFilter.key]}
                                      submited={submited}
                                      touched={touched[formFields.advertiserFilter.key]}
                                      options={advertiserOptions}
                                    />
                                  </div>
                                  <div className='col-md-12 mb-2'>
                                    <label className="mr-2 mb-2">Platform</label>
                                    <SelectNew
                                      onChange={handleChange}
                                      onBlur={handleTouch}
                                      value={form[formFields.platformCloneFilter.key]}
                                      setting={formFields[formFields.platformCloneFilter.key]}
                                      error={errors[formFields.platformCloneFilter.key]}
                                      submited={submited}
                                      touched={touched[formFields.platformCloneFilter.key]}
                                      options={platformOptions}
                                    />
                                  </div>
                                  <div className='col-md-12 mb-2'>
                                    <label className="mr-2 mb-2">Account Owner</label>
                                    <SelectNew
                                      onChange={handleChange}
                                      onBlur={handleTouch}
                                      value={form[formFields.accountOwnerFilter.key]}
                                      setting={formFields[formFields.accountOwnerFilter.key]}
                                      error={errors[formFields.accountOwnerFilter.key]}
                                      submited={submited}
                                      touched={touched[formFields.accountOwnerFilter.key]}
                                      options={accountOwnerOptions}
                                    />
                                  </div>
                                  <div className="col-md-12 mt-2 justify-content-end d-flex">
                                    <button onClick={() => resetAdvertiserConnectionFilters()} className="btn btn-outline-primary">
                                      Reset
                                    </button>
                                    <button onClick={() => {
                                      getAdvertisersConnectionList();
                                      setAdvertisersConnectionPopover(!advertisersConnectionPopover);
                                    }} className="btn btn-primary bg-color-beki ml-3">
                                      Apply
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>


                        <div className='campaign-adj'>
                          <div className="campaign-list-adj table-responsive">
                            <Table
                              options={advertisersConnectionOptionsList}
                              data={advertisersConnectionList || []}
                              handelAction={handleAdvertisersConnectionAction}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </div>

        </div>
      </div>

    </>
  )
}

export default withRouter(List);